import Vue from 'vue';

export function roundPrice(num:number){
    if(('' + num).indexOf('e')===-1) {
        return +(Math.round(parseFloat(num + 'e+' + 2))  + 'e-' + 2);
    } else {
        const arr = ('' + num).split('e');
        let sig = '';
        if(+arr[1] + 2 > 0) {
            sig = '+';
        }
        return +(Math.round(parseFloat(+arr[0] + 'e' + sig + (+arr[1] + 2))) + 'e-' + 2);
    }
}

export function formatPrice(v:any) {
    if (isNaN(v)) {return '';}
    const result = '$' + insertDelimeters(roundPrice(v), 2);
    return result;
}

export function insertDelimeters(v:number, n:number, x?:number) {
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return v.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

export function parsePrice (str:string) {
    const clean_str = str.replace(/[\\$, ]+/g, '').trim();
    return parseFloat(clean_str);
}

export function DateToJson(d:Date, offset:number){
    return '/Date('+d.getUTCMilliseconds()+''+ offset+')/';
}

export function formatDate(str: string) {

    const d=  new Date(str);
    var local = new Date(d.toUTCString());
    return local.toLocaleString();
}

export function formatDateNoSeconds(str: string) {

    const d=  new Date(str);
    var local = new Date(d.toUTCString());
    return local.toLocaleString([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'});
}

export function removeDateStrTimezone(str: string) {
    return str?str.substring(0, str.indexOf('T')):'';
}

export function extractJsonDate(str:any):Date{
    const d = new Date(parseInt(str.match(/\d+/)[0]) * 1);
    return d;
}

export function extractJsonDateWithOffset(str:any){

    // var offsetS = str.substring(str.search(/[-+]\d+/)+1);
    let hours,minutes;
    // sign = offsetS[0];
    /*if (offsetS[0] =="0"){
        hours = parseInt(offsetS.substring(1,2));
    } else {
        hours = parseInt(offsetS.substring(0,2));
    }
    minutes = parseInt(offsetS.substring(2,4));
    if (sign>0)
        d.setTime(d.getTime()+ (hours*3600*1000) + (minutes*60*1000));
    else
        d.setTime(d.getTime()- (hours*3600*1000) - (minutes*60*1000));*/
    return {Date:extractJsonDate(str), offset: str.match(/[-+]\d+/)[0]};
}

export function offsetToMilliseconds(offsetS:string){
    const sign = offsetS[0];
    let hours, minutes;
    if (offsetS[0] ==='0'){
        hours = parseInt(offsetS.substring(1,2));
    } else {
        hours = parseInt(offsetS.substring(0,2));
    }
    minutes = parseInt(offsetS.substring(2,4));
    if (sign=='+') {
        return hours*3600*1000 + minutes*60*1000;
    }
    else {
        return - (hours*3600*1000) - minutes*60*1000;
    }
}

export function formatDateTime(str:string) {

    const d=  new Date(str);
    var local = new Date(d.toUTCString());
    return local.toLocaleString();
}

export function formatDateQuery(str:string) {

    const d=  new Date(str);
    var day = d.getDate();
      var monthIndex = d.getMonth() + 1;
      var year = d.getFullYear();
    
      return monthIndex + '-' + day + '-' + year;
}

export function formatDateLong(str:string) {
      const d=  new Date(str);
      return d.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric'});
}

export function formatDate2(str:string) {

    var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];
      const d=  new Date(str);

      var day = d.getDate();
      var monthIndex = d.getMonth();
      var year = d.getFullYear();
    
      return monthNames[monthIndex] + ' ' + day + ', ' + year;
}

export function formatFixed(n:number) {
    return  (Math.round(n * 100) / 100).toFixed(2);
}

export function formatTime(str:string) {

    const d=  new Date(str);
    var local = new Date(d.toUTCString());
    return local.toLocaleTimeString();
}

export function formatHourMinute(str:string) {

    const d = new Date(str);
    const local = new Date(d.toUTCString());

    let hours = local.getHours();
    let minutes = local.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? 0 + minutes : minutes;

    return hours + ':' + minutes + ' ' + ampm;
}

Vue.filter('formatDate2', formatDate2);
Vue.filter('formatDateLong', formatDateLong);
Vue.filter('formatDateQuery', formatDateQuery);
Vue.filter('formatFixed', formatFixed);
Vue.filter('formatTime', formatTime);
Vue.filter('formatHourMinute', formatHourMinute);
Vue.filter('formatDateNoSeconds', formatDateNoSeconds);